import { palette } from '.';
export const colorMappings = {
  RETAIL_COLOR_MAPPING: {
    red: palette.simpleRed,
    simpleRed: palette.simpleRed,
    zeusBlackUI: palette.zeusBlackUI,
    solidWhite: palette.solidWhite,
    flushOrange: palette.flushOrange,
    brightRedUI: palette.brightRedUI,
    endeavourBlueUI: palette.endeavourBlueUI,
    endeavourBlueUIHover: palette.endeavourBlueUIHover,
    funGreen: palette.funGreen,
    funGreenUI: palette.funGreenUI
  },
  YOUNG_COLOR_MAPPING: {
    red: palette.simpleGreen,
    simpleRed: palette.simpleGreen,
    zeusBlackUI: palette.shockingPink,
    solidWhite: palette.solidWhite,
    flushOrange: palette.simpleBlueUI,
    brightRedUI: palette.shockingPink,
    endeavourBlueUI: palette.endeavourBlueUI,
    endeavourBlueUIHover: palette.endeavourBlueUIHover,
    funGreen: palette.simpleBlueUI,
    funGreenUI: palette.simpleBlueUIHover
  },
  AFFLUENT_COLOR_MAPPING: {
    red: palette.brightRedUI,
    simpleRed: palette.brightRedUI,
    zeusBlackUI: palette.selectiveYellow,
    solidWhite: palette.solidWhite,
    flushOrange: palette.midGrayUI,
    brightRedUI: palette.monzaRed,
    endeavourBlueUI: palette.flirtPinkUI,
    endeavourBlueUIHover: palette.flirtPinkUIHover,
    funGreen: palette.clementineOrange,
    funGreenUI: palette.clementineOrange
  },
  CORPORATE_COLOR_MAPPING: {
    red: palette.chathamsBlue,
    simpleRed: palette.chathamsBlue,
    zeusBlackUI: palette.opalGray,
    solidWhite: palette.solidWhite,
    flushOrange: palette.ceruleanBlue,
    brightRedUI: palette.midGrayUI,
    endeavourBlueUI: palette.flushOrange,
    endeavourBlueUIHover: palette.flushOrange,
    funGreen: palette.daintreeBlue,
    funGreenUI: palette.daintreeBlue
  },
  SME_COLOR_MAPPING: {
    red: palette.funGreen,
    simpleRed: palette.funGreen,
    zeusBlackUI: palette.flushOrange,
    solidWhite: palette.solidWhite,
    flushOrange: palette.taraweraBlue,
    brightRedUI: palette.pistachioGreen,
    endeavourBlueUI: palette.zeusBlackUI,
    endeavourBlueUIHover: palette.zeusBlackUI,
    funGreen: palette.camaroneGreenUI,
    funGreenUI: palette.camaroneGreenUI
  },
  PRIVATE_BANKING_COLOR_MAPPING: {
    red: palette.duneBrown,
    simpleRed: palette.duneBrown,
    zeusBlackUI: palette.brightRedUI,
    solidWhite: palette.solidWhite,
    flushOrange: palette.twineBrown,
    brightRedUI: palette.millbrookBrownUI,
    endeavourBlueUI: palette.nileBlueUI,
    endeavourBlueUIHover: palette.nileBlueUI,
    funGreen: palette.zeusBlackUI,
    funGreenUI: palette.zeusBlackUI
  }
};